<button
  type="button"
  class="munily-panel"
  [class.munily-panel--borderless]="isBorderless"
  (click)="onClick()"
>
  <div class="munily-panel__header">
    <div class="munily-panel__header-left">
      <p class="munily-panel__title s1_500" [class.munily-panel__title--muted]="isTitleMuted">{{ title }}</p>
      <p *ngIf="showDescription" class="munily-panel__description-text">{{ description }}</p>
    </div>

    <div class="munily-panel__header-right">
      <ng-container *ngIf="headerRightTemplate; else defaultHeaderRight">
        <div (click)="$event.stopPropagation()">
          <ng-container
            [ngTemplateOutlet]="headerRightTemplate"
            [ngTemplateOutletContext]="{ $implicit: headerRightContext }"
          ></ng-container>
        </div>
      </ng-container>

      <ng-template #defaultHeaderRight>
        <p *ngIf="showSubtitle" class="munily-panel__subtitle s1_500">{{ subtitle }}</p>
        <mat-icon *ngIf="showChevron" class="munily-panel__chevron" aria-hidden="true">arrow_forward_ios</mat-icon>
      </ng-template>
    </div>
  </div>

  <div
    *ngIf="hasFooterContent"
    class="munily-panel__footer"
    (click)="$event.stopPropagation()"
  >
    <ng-container *ngIf="footerTemplate; else defaultFooter">
      <ng-container [ngTemplateOutlet]="footerTemplate" [ngTemplateOutletContext]="{ $implicit: footerContext }">
      </ng-container>
    </ng-container>

    <ng-template #defaultFooter>
      <p
        *ngFor="let desc of visibleDescriptions"
        class="munily-panel__description"
      >
        {{ desc.text }}
      </p>
    </ng-template>
  </div>
</button>
